import actions from './_actions';
import getters from './_getters';
import mutations from './_mutators';

const state = {
    s: null,
    is_loading: false,
    original_filename: null,
    file: null,
    project_id: null,
    files: {
        // Perhaps I shouldn't limit client and student from uploading but only
        // limit number of files associated with project? 
        // max_client_upload: 10,
        // max_student_upload: 10,
        max_project_upload: 20,
        all: null,
        project: null,
        share: null,
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/store/index.js